import { useSafeWindow } from '@/composables/utils/useSafeWindow';
import { useScrollToElement } from '@/composables/utils/useScrollToElement';

const DEFAULT_OFFSET_Y = -80;

/**
 * KV ボタンなどからセクションへスクロールするための composable。
 * useSafeWindow + useScrollToElement を内包し、ref のみ渡せば同じパターンで使える。
 */
export const useScrollToSection = (target: Ref<HTMLElement | null>, options?: { offsetY?: number }) => {
  const { window: windowRef } = useSafeWindow();
  const offsetY = options?.offsetY ?? DEFAULT_OFFSET_Y;
  const { scrollTo } = useScrollToElement({
    target,
    window: windowRef,
    offsetY,
  });
  return { scrollTo };
};
